import BobjectName from './bobjectName.view';

export default BobjectName;
